var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 9.48628V12.4363H17.13C17.32 12.4363 17.46 12.6063 17.42 12.7963L17.04 14.6963C17.01 14.8363 16.89 14.9363 16.75 14.9363H14.5V22.1863H11.5V14.9363H9.8C9.63 14.9363 9.5 14.8063 9.5 14.6363V12.7363C9.5 12.5663 9.63 12.4363 9.8 12.4363H11.5V9.18628C11.5 7.52628 12.84 6.18628 14.5 6.18628H17.2C17.37 6.18628 17.5 6.31628 17.5 6.48628V8.88628C17.5 9.05628 17.37 9.18628 17.2 9.18628H14.8C14.63 9.18628 14.5 9.31628 14.5 9.48628Z",
    stroke: "#4DFFFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 13.0163V15.1863C2.5 20.1863 4.5 22.1863 9.5 22.1863H15.5C20.5 22.1863 22.5 20.1863 22.5 15.1863V9.18628C22.5 4.18628 20.5 2.18628 15.5 2.18628H9.5C4.5 2.18628 2.5 4.18628 2.5 9.18628",
    stroke: "#4DFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.d50acea44d90bd53cd3fbe1c861aca77.svg";
export { ForwardRef as ReactComponent };